'use client';

import classnames from 'classnames/bind';
import { EColors } from '@/_types';
import styles from './index.module.scss';

const cn = classnames.bind(styles);
const BLOCK_NAME = 'DiagonalArrowRightIcon';

type TProps = {
  color?: EColors;
};

export const DiagonalArrowRightIcon = ({ color = EColors.BLACK }: TProps) => {
  return (
    <svg fill="none" height="17" width="16" xmlns="http://www.w3.org/2000/svg">
      <path
        className={cn(BLOCK_NAME, `${BLOCK_NAME}--${color}`)}
        clipRule="evenodd"
        d="M3.527 12.887a.667.667 0 0 1 0-.942l6.196-6.196H5.665a.667.667 0 1 1 0-1.333h5.667a.667.667 0 0 1 .667.667v5.666a.667.667 0 0 1-1.334 0V6.692L4.47 12.887a.667.667 0 0 1-.943 0z"
        fill="#000"
        fillRule="evenodd"
      />
    </svg>
  );
};
